type ClerkTokenGetter = (options?: { template?: string }) => Promise<string | null>

let clerkTokenGetter: ClerkTokenGetter | null = null

export function setClerkTokenGetter(getter: ClerkTokenGetter) {
  clerkTokenGetter = getter
}

export function getClerkTokenGetter(): ClerkTokenGetter {
  if (!clerkTokenGetter) {
    throw new Error("Clerk token getter not initialized. Call setClerkTokenGetter first.")
  }
  return clerkTokenGetter
}
